<mat-radio-group [(ngModel)]="getStateService().status" class="d-flex flex-column">
    <mat-radio-button value="1">Active</mat-radio-button>
    <mat-radio-button value="2">Inactive</mat-radio-button>
</mat-radio-group>